import React from "react";
const RenderStars = ({ rating }) => {
  const full = Math.max(0, Math.min(5, rating)); // 0-5 sınırı
  const empty = 5 - full;

  return (
    <div className="text-warning mb-1">
      {[...Array(full)].map((_, i) => (
        <i key={`full-${i}`} className="bi bi-star-fill me-1"></i>
      ))}
      {[...Array(empty)].map((_, i) => (
        <i key={`empty-${i}`} className="bi bi-star me-1"></i>
      ))}
    </div>
  );
};

export default RenderStars;
